import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconInboxPoint = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1106_1168)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9 7C10.0938 7 11 7.90625 11 9C11 10.0938 10.0938 11 9 11C7.90625 11 7 10.0938 7 9C7 7.90625 7.90625 7 9 7Z",
			fill: "#C5C5C5"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1106_1168",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export default SvgIconInboxPoint;
